<table style="margin-left: auto;margin-right: auto;">
    <tr>
        <td>
            <svg id="logo" viewBox="0 0 90 32" width="80" height="80">
                <path
                    d="M15.401 2C7.84 2.25 1.876 8.475 2.002 15.986c.126 7.51 6.295 13.534 13.862 13.534 7.566 0 13.735-6.023 13.861-13.534C29.851 8.475 23.888 2.25 16.325 2h-.924zm19.41 0c-7.563.25-13.526 6.475-13.4 13.986.126 7.51 6.295 13.534 13.862 13.534 7.566 0 13.735-6.023 13.861-13.534C49.26 8.475 43.297 2.25 35.734 2h-.924zm19.408 0c-7.562.25-13.525 6.475-13.4 13.986.127 7.51 6.296 13.534 13.863 13.534 7.566 0 13.735-6.023 13.861-13.534C68.67 8.475 62.706 2.25 55.143 2h-.924zm19.41 0c-7.563.25-13.526 6.475-13.4 13.986.126 7.51 6.295 13.534 13.862 13.534 7.566 0 13.735-6.023 13.861-13.534C88.078 8.475 82.115 2.25 74.552 2h-.924z"
                    stroke="#000" stroke-width="3.584" fill="none" fill-rule="evenodd"></path>
            </svg>
        </td>
        <td>
            <p style="font-size:18px;">&nbsp;&nbsp;Cookie Settings</p>
        </td>
    </tr>
</table>

<p>
    On our website, we use services (including from third-party providers) that help us to improve our online presence (optimization of website)
    and to display content that is geared to their interests (marketing). The following categories of cookies, listed below, are used by us and can be managed in the cookie
    settings. We need your consent before being able to use these services. You can revoke this consent at any time with future effect in the footer area of the website under
    "Cookie Settings". For further information, please see our
    <a href="https://www.audi.co.za/za/web/en/tools/navigation/layer/legal/cookie-policy.html" target="_blank">Cookie Policy</a>,
    our <a href="https://www.audi.co.za/za/web/en/privacy-statement.html" target="_blank">Privacy Policy</a>
    and the <a href="https://www.audi.co.za/za/web/en/audi-terms-and-conditions.html" target="_blank">Legal Notice</a>.
</p>

<div style="width:100%;margin:auto;text-align:center;">
    <app-audi-button text="Accept" className="audi-button-wide" (click)="onAcceptCookies()"></app-audi-button>
    <br /><br />
    <app-audi-button text="Decline" className="audi-button-wide" variant="secondary" (click)="onDeclineCookies()"></app-audi-button>
</div>

<br />
<div style="border-top:1px solid lightgray;">
    <p style="font-size:16px;">Essential Cookies</p>
    <p style="font-size:14px;">Essential cookies are required to provide you with basic functions while using the website. These functions include the vehicle details, for example.
    </p>
</div>